import { render, staticRenderFns } from "./EventDates.vue?vue&type=template&id=4098b9e2"
import script from "./EventDates.vue?vue&type=script&lang=js"
export * from "./EventDates.vue?vue&type=script&lang=js"
import style0 from "./EventDates.vue?vue&type=style&index=0&id=4098b9e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports